import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './pc-layout-two-col-border.css.lit';
import { classMap } from 'lit/directives/class-map.js';

import '../pc-container/pc-container';

export const backgroundColors = [
  'primary-eggplant',
  'purple-indigo',
  'purple-indigo-light',
  'purple-medium-neutra',
  'neutral-medium-gray',
  'primary-white',
] as const;
export type BackgroundColor = (typeof backgroundColors)[number];

/**
 * Layout two column border component
 * @element pc-layout-two-col-border
 * @slot - This element has a default slot
 * @attr clickable-card
 */
@customElement('pc-layout-two-col-border')
export class PCLayoutTwoColBorder extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  slots = new SlotsController(this);

  /**
   * clickable-card
   **/
  @property({ type: Boolean, reflect: true, attribute: 'clickable-card' })
  clickableCard = false;

  /**
   * Adds top border
   */
  @property({ type: Boolean, reflect: true, attribute: 'divider' })
  divider: boolean;

  /**
   * Adds bottom border
   */
  @property({ type: Boolean, reflect: true })
  enclosed: boolean;

  /**
   * Sets gap to 0
   */
  @property({ type: Boolean, reflect: true })
  degap: boolean;

  /**
   * Sets background color
   */
  @property({ type: String, attribute: 'background-color' })
  backgroundColor: BackgroundColor;

  updated() {
    this.setBGColorVar();
  }

  setBGColorVar() {
    this.style.setProperty('--bg-color', `var(--${this.backgroundColor})`);
  }

  render(): TemplateResult {
    const classes = {
      'grid': true,
      'clickable-card': !!this.clickableCard,
    };
    return html`
      <div class="layout-two-col-border">
        <pc-container>
          <div class="${classMap(classes)}">
            ${this.slots.conditionalSlot('column-left', false)}
            ${this.divider ? html`<div class="divider"></div>` : null}
            ${this.slots.conditionalSlot('column-right', false)}
          </div>
        </pc-container>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-layout-two-col-border': PCLayoutTwoColBorder;
  }
}
